import axios from "axios";
import HttpHeader from '../header';
import { client } from "../index";
import { CONSUMER_GET_DOWNLOAD_URL } from "../graphql/documents/consumerGetS3ObjectSignedUrl";
import { checkDeleteOrDownloadFileType } from "../components/utils";

const httpHeader = HttpHeader.getInstance();

const instance = axios.create({
  baseURL: process.env.REACT_APP_APOLLO_SERVER,
  headers: {
    'Content-Type': 'application/json'
  }
});

instance.interceptors.request.use(async function (config) {
  config.headers = {
    ...config.headers,
    ...httpHeader.headers,
    ...(httpHeader.headers.authorization && { authorization: `Bearer ${httpHeader.headers.authorization}` })
  };
  return config;
});

export const signedUrlAPI = (key: string) => instance.post("/", {
  query: `query signedUrl($key: String!) {
    consumerGetS3ObjectSignedUrl(key: $key)
  }`,
  variables: {
    key
  }
})

// export const getSignedUrl = async (key: string) => {
//   const { data } = await signedUrlAPI(key);
//   return data.data.consumerGetS3ObjectSignedUrl;
// }

export const getSignedUrl = async (
  fileKey: string
): Promise<string> => {
  try {
    const { data } = await client.query({
      query: CONSUMER_GET_DOWNLOAD_URL,
      variables: { key: fileKey },
      fetchPolicy: "network-only",
    });
    return data.consumerGetS3ObjectSignedUrl;
  } catch (error: any) {
    return '';
  }
};

export async function downloadTermsAndConditions(conditionsUrl: string) {
  const { fileExtension, contentType } = checkDeleteOrDownloadFileType(
    conditionsUrl
  );
  const config = { contentType, level: "public" };
  const file = await getSignedUrl(conditionsUrl);
  const url: any = file;
  fetch(url, {
    method: "GET"
  })
    .then((response) => response.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `TermsAndConditions.${fileExtension}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    });
}